export const ADD_STEP = 'ADD_STEP';
export const REMOVE_STEP = 'REMOVE_STEP';
export const RESET_STEPS = 'RESET_STEPS';
export const UTM_SOURCE = 'UTM_SOURCE';
export const UTM_CAMPAIGN = 'UTM_CAMPAIGN';